import { connect } from 'react-redux';

import BaseProductList from './base/base-product-list';

import HomePage from '../components/pages/home-page';

const mapStateToProps = (state, ownProps) => ({
    storesGrouped: state.stores.storesGrouped,
});

const mapDispatchToProps = (dispatch) => ({

});

const HomePageConnector = connect(mapStateToProps, mapDispatchToProps)(HomePage);

export default BaseProductList(HomePageConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/home-page-connector.js
 **/